export default __webpack_public_path__ + "static/media/00.815bb8ad.jpg";